// extracted by mini-css-extract-plugin
export default {"footerBg":"Footer_footerBg__H4qKn"};